<template>
    <a-table :columns="columns" :dataSource="data" rowKey='id'
    :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">
        <span slot="status" slot-scope="text, row">
            <a-tag :color="(row.status)?'green':'red'">
                {{(row.status)?'ใช้งานได้':'บล็อค'}}
            </a-tag>
        </span>
        <a-dropdown slot="Action" slot-scope="text, row">
            <a-menu slot="overlay" >
                <a-menu-item key="1" @click="getDetailRoleAdmin(row.id)"> <a-icon type="edit" />เเก้ไขสิทธิ์การเข้าถึง</a-menu-item>
                <a-menu-item key="2" @click="manageManu(row.id)"> <a-icon type="setting" />จัดการเมนู</a-menu-item>
                <a-menu-item key="3" @click="block(row)"> <a-icon type="close" /> {{(!row.status)?'เลิกบล็อค':'บล็อค'}}</a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px">จัดการ <a-icon type="down" /> </a-button>
        </a-dropdown>
    </a-table>
</template>

<script>
import apiClient from '@/services/api'
import useNoti from '@/services/plugin/notification'
import moment from 'moment'
export default {
  name: 'TableRoleAdmin',
  props: [
    'isReload',
  ],
  data() {
    return {
      data: [],
      columns: [
        {
          title: '',
          key: '',
          customRender: (text, row, index) => {
            return (index + 1)
          },
        },
        {
          title: 'ชื่อสิทธิ์การเข้าถึง',
          key: 'name',
          dataIndex: 'name',
        },
        {
          title: 'สถานะ',
          key: 'status',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: 'สร้างเมื่อ',
          key: 'createdAt',
          dataIndex: 'createdAt',
          customRender: (text, row, index) => {
            return moment(text).format('DD/MM/YYYY HH:mm:ss')
          },
        },
        {
          title: 'จัดการ',
          key: 'Action',
          dataIndex: 'id',
          scopedSlots: { customRender: 'Action' },
        },
      ],
    }
  },
  watch: {
    isReload() {
      if (this.isReload) {
        this.reload()
      }
    },
  },
  methods: {
    async getDataRoleAdmin() {
      await apiClient.get('/roleAdmin', { }).then(response => {
        const res = response.data
        if (res.code === '000') {
          this.data = res.responseData.data
        }
      }).catch(err => {
        useNoti('error', 'Error', err.message)
      })
    },
    reload() {
      this.getDataRoleAdmin()
      this.$emit('clear-reload')
    },
    manageManu(id) {
      this.$emit('mange-submitted', id)
    },
    getDetailRoleAdmin(id) {
      this.$emit('edit-submitted', id)
    },
    block(result) {
      this.$emit('block-submitted', result)
    },
  },
  created() {
    this.getDataRoleAdmin()
  },
}
</script>

<style>

</style>
